// Notes API → backend /notes router. Per-user personal notes.
import { api } from "./client";

export const listNotes = () => api.get("/notes");
export const createNote = (data) => api.post("/notes", data);
export const updateNote = (id, data) => api.put(`/notes/${id}`, data);
export const deleteNote = (id) => api.del(`/notes/${id}`);
